/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  faFloppyDisk,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useState } from "react";
import { Button, CardHeader, Col, Row, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { Card, CardBody, Label } from "reactstrap";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import ButtonComponent from "../../../../components/ButtonComponent";
import ControlledRowSelectPortion from "../../../../components/ControlledRowSelectPortion";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import ControlledSelect from "../../../../components/ControlledSelect";
import MenuItemImageUpdate, {
  UpdateImageDetails,
} from "../../../../components/MenuItemImageUpdate/MenuItemImageUpdate";
import ControlledRowTextFieldForPortion from "../../../../components/RowTextFieldsForPortions";
import { DELIVERY_TIME } from "../../../../dummyData/dummyData";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import { CreateMenuItem } from "../../../../redux/menuSlice";
import {
  useLazyGetDimensionsQuery,
  useLazyGetMenuTypesQuery,
  useLazyGetPortionSizesQuery,
} from "../../../../redux/services/CustomTypeService";
import {
  useCreateMenuItemMutation,
  useGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetAllOrganizationsQuery,
  useLazyGetRestaurantFilterTagsQuery,
} from "../../../../redux/services/menuItemService";
import "./index.css";

const AddItemForm = () => {
  const navigate = useNavigate();

  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id,
  );

  function capitalizeFirstLetter(string: string): string {
    if (!string) return string;
    return string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const restaurantData = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails,
  );

  // Image upload state management
  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [imageOrder, setImageOrder] = useState<string[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [buttonText, setButtonText] = useState("Save");
  const [canCustomize, setCanCustomize] = useState(false);
  const [canPortion, setCanPortion] = useState(false);
  const [isPreOrder, setIsPreOrder] = useState(false);
  const [isCooporateProduct, setisCooporateProduct] = useState(false);
  const [isCanSellProduct, setIsCanSellProduct] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [portionSize, setPortionSize] = useState("");
  const [portionPrice, setPortionPrice] = useState("");
  const [portions, setPortions] = useState<
    { displayName: string; additionalCost: number }[]
  >([]);
  const [portionErrorMessage, setPortionErrorMessage] = useState<string | null>(
    null,
  );
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [organizationOptions, setOrganizationOptions] = useState<any[]>([]);
  const [selectedcustomMenuItemTypeId, setSelectedcustomMenuItemTypeId] =
    useState<string | null>(null);
  const [selectedDimensionValues, setSelectedDimensionValues] = useState<{
    [dimensionId: string]: any;
  }>({});

  const [isPortionPriceDisable, setIsPortionPriceDisable] =
    useState<boolean>(false);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    setError,
    clearErrors,
    watch,
    trigger,
  } = useForm<CreateMenuItem>({
    defaultValues: {
      category: "",
      description: "",
      displayName: "",
      abbreviation: "",
      imageUrl: [],
      mealType: "",
      preparingTime: "",
      price: 0,
      restaurantId: RestID,
      isCustomMenuItem: false,
      customMenuItemSection: "",
      supportsPreOrdering: false,
      supportPortionSizes: false,
      portions: [],
      portionSize: "",
      portionPrice: 0,
      allergenInformation: [],
      foodAttributes: [],
      filterTags: [],
      productId: "",
      isCooporateProduct: false,
      organizationIds: [],
      tinyId: undefined,
      isSellingProduct: false,
    },
  });

  // Watch for changes in corporate support and organizations
  const watchIsCooporateProduct = watch("isCooporateProduct");
  const watchOrganizationIds = watch("organizationIds");

  // Validate organizations when corporate support or organizations change
  useEffect(() => {
    if (watchIsCooporateProduct) {
      trigger("organizationIds");
    }
  }, [watchIsCooporateProduct, watchOrganizationIds, trigger]);

  const [createMenuItem, { isSuccess }] = useCreateMenuItemMutation();
  // const [uploadMenuItemFileExtention] =
  //   useUploadMenuItemLogoFileExtntionHttpsMutation();
  const [
    getAllOrganizations,
    { data: organizationsData, isLoading: isOrganizationsLoading },
  ] = useLazyGetAllOrganizationsQuery();

  const { data: allergenData } = useGetAllergenInformationQuery();
  const { data: foodAttributesData } = useGetFoodAttributesListQuery();

  // Image upload callback handler for MenuItemImageUpdate component
  const imageUpdateCallbackHandler = useCallback((e: UpdateImageDetails) => {
    // For new images (oldImgUrl is empty)
    if (!e.oldImgUrl || e.oldImgUrl === "") {
      if (e.newImgRef) {
        setUploadedImages((prev) => [...prev, e.newImgRef as string]);
      }
    }
    // For image replacements
    else if (e.newImgRef !== undefined) {
      setUploadedImages((prev) =>
        prev.map((img) =>
          img === e.oldImgUrl ? (e.newImgRef as string) : img,
        ),
      );
    }
    // For deletions (newImgRef is undefined)
    else {
      setUploadedImages((prev) => prev.filter((img) => img !== e.oldImgUrl));
    }
  }, []);

  // Fetch menu types from the API
  const [
    triggerGetMenuTypes,
    { data: menuTypes = [], isLoading: isMenuTypesLoading },
  ] = useLazyGetMenuTypesQuery();

  // Fetch dimensions for selected custom menu type
  const [
    triggerGetDimensions,
    { data: dimensionsData = [], isLoading: isDimensionsLoading },
  ] = useLazyGetDimensionsQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetMenuTypes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetMenuTypes]);

  // Fetch dimensions when custom menu type is selected
  useEffect(() => {
    if (RestID && selectedcustomMenuItemTypeId) {
      triggerGetDimensions({
        restaurantId: RestID,
        customMenuItemTypeId: selectedcustomMenuItemTypeId,
      });
    }
  }, [RestID, selectedcustomMenuItemTypeId, triggerGetDimensions]);

  // Fetch Portion Sizes from the API
  const [triggerGetPortionSizes, { data: portionSizesData = [] }] =
    useLazyGetPortionSizesQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetPortionSizes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetPortionSizes]);

  // Load organizations when component mounts or when corporate support is enabled
  useEffect(() => {
    if (isCooporateProduct) {
      getAllOrganizations();
    }
  }, [isCooporateProduct, getAllOrganizations]);

  // Clear image error when images are uploaded
  useEffect(() => {
    if (uploadedImages.length > 0) {
      clearErrors("imageUrl");
    }
  }, [uploadedImages, clearErrors]);

  // Filter organizations based on search input
  useEffect(() => {
    if (organizationsData && organizationSearch) {
      const filtered = organizationsData
        .filter(
          (org) =>
            org.displayName
              .toLowerCase()
              .includes(organizationSearch.toLowerCase()) ||
            org.code.toLowerCase().includes(organizationSearch.toLowerCase()),
        )
        .map((org) => ({
          value: org.organizationId,
          label: `${org.displayName} (${org.code})`,
        }));
      setOrganizationOptions(filtered);
    } else if (organizationsData) {
      const allOptions = organizationsData.map((org) => ({
        value: org.organizationId,
        label: `${org.displayName} (${org.code})`,
      }));
      setOrganizationOptions(allOptions);
    }
  }, [organizationsData, organizationSearch]);

  // Map portion sizes data to select options
  const portionSizesOptions = portionSizesData.map((size) => ({
    value: size.portionSize,
    label: size.portionSize,
  }));

  // Map category data to select options
  const menuCategories: any = restaurantData?.categoryTags.map((value: any) => {
    return {
      value: capitalizeFirstLetter(value),
      label: capitalizeFirstLetter(value),
    };
  }) || [{ value: "", label: "" }];

  const [
    triggerGetFilterTags,
    { data: filterTagsData, isLoading: isFilterTagsLoading },
  ] = useLazyGetRestaurantFilterTagsQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetFilterTags(RestID);
    }
  }, [RestID, triggerGetFilterTags]);

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    // Iterate over each category in filterTags
    Object.entries(filterTagsData.filterTags).forEach(
      ([category, categoryData]) => {
        if (categoryData.tags && Array.isArray(categoryData.tags)) {
          categoryData.tags.forEach((tag) => {
            if (tag.show) {
              options.push({ value: tag.tag, label: `${tag.tag}` });
            }
          });
        }
      },
    );

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  // Map allergen data to select options with icons
  const allergenOptions =
    allergenData?.allergenInformation.map((allergen) => ({
      value: allergen.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(allergen.displayName)}
            alt={allergen.displayName}
            width="20px"
            height="20px"
          />
          {allergen.displayName}
        </div>
      ),
    })) || [];

  // Map food attributes data to select options
  const foodAttributesOptions =
    foodAttributesData?.FoodAttributesList.map((attr) => ({
      value: attr.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(attr.displayName)}
            alt={attr.displayName}
            width="20px"
            height="20px"
          />
          {attr.displayName}
        </div>
      ),
    })) || [];

  // Validation function for organizations
  const validateOrganizations = (value: any[], isCooporateProduct: boolean) => {
    if (isCooporateProduct && (!value || value.length === 0)) {
      return "At least one organization is required when corporate support is enabled";
    }
    return true;
  };

  const createMenuMutate = async (data: CreateMenuItem) => {
    try {
      const response: any = await createMenuItem(data);
      if (
        response?.error?.status === 409 &&
        response?.error?.data === "ProductId Already exists"
      ) {
        toast.error("Product ID already exists");
        return;
      }
      if (
        response?.error?.status === 409 &&
        response?.error?.data === "This Product name already used"
      ) {
        toast.error("Product name already exists");
        return;
      }
      if (
        response?.error?.status === 409 &&
        response?.error?.data === "This menu item name already used"
      ) {
        toast.error("Product name already exists");
        return;
      }
      toast.success("Product created");
      setButtonText("Saved");
      reset();
      if (!isSuccess) {
        navigate("/productCatalogue/stock-keeping-unit");
      }
    } catch (error: any) {
      if (error.status === 409) {
        toast.error("Product name already exists");
      }
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = async (data: CreateMenuItem) => {
    // Validate images
    // if (uploadedImages.length === 0) {
    //   setError("imageUrl", {
    //     type: "manual",
    //     message: "At least one image is required",
    //   });
    //   return;
    // }
    clearErrors("imageUrl");

    // Validate corporate support organizations
    if (
      data.isCooporateProduct &&
      (!data.organizationIds || data.organizationIds.length === 0)
    ) {
      setError("organizationIds", {
        type: "manual",
        message:
          "At least one organization is required when corporate support is enabled",
      });
      return;
    }
    clearErrors("organizationIds");

    // Validate custom menu section
    if (canCustomize && !data.customMenuItemSection) {
      setError("customMenuItemSection", {
        type: "manual",
        message: "Please fill the Custom Product Section.",
      });
      return;
    }
    clearErrors("customMenuItemSection");

    // Validate required dimensions
    if (
      canCustomize &&
      selectedcustomMenuItemTypeId &&
      dimensionsData.length > 0
    ) {
      for (const dimension of dimensionsData) {
        if (dimension.isRequired && !selectedDimensionValues[dimension.id]) {
          toast.error(`${dimension.displayName} is required`);
          return;
        }
      }
    }

    setButtonText("");
    setIsLoading(true);

    // Use image order if available, otherwise use uploaded images
    const finalImageUrls = imageOrder.length > 0 ? imageOrder : uploadedImages;

    const structuredTags: { [key: string]: string[] } = {};

    // Loop through selected tags and group by category
    if (filterTagsData?.filterTags && data.filterTags) {
      Object.entries(filterTagsData.filterTags).forEach(
        ([categoryKey, categoryData]) => {
          const selectedTags = (data.filterTags ?? [])
            .map((tag: any) => tag.value)
            .filter((tagValue: string) =>
              (categoryData.tags as any[]).some(
                (tagObj) => tagObj.tag === tagValue,
              ),
            );

          if (selectedTags.length > 0) {
            structuredTags[categoryKey.toLowerCase()] = selectedTags.map(
              (tag: string) => tag.toLowerCase(),
            );
          }
        },
      );
    }

    // Extract organization IDs from selected organizations
    const selectedOrganizationIds = data.organizationIds
      ? data.organizationIds.map((org: any) => org.value)
      : [];

    // Extract selected dimension values and transform to required format
    const dimensionSelections =
      canCustomize &&
        selectedcustomMenuItemTypeId &&
        Object.keys(selectedDimensionValues).length > 0
        ? Object.entries(selectedDimensionValues).reduce(
          (acc, [dimensionId, selectedValue]) => {
            if (selectedValue?.value) {
              acc[dimensionId] = {
                dimensionValueId: selectedValue.value,
              };
            }
            return acc;
          },
          {} as { [dimensionId: string]: { dimensionValueId: string } },
        )
        : undefined;

    const object: CreateMenuItem = {
      category: data.category.value,
      description: data.description,
      displayName: data.displayName,
      abbreviation: data.abbreviation,
      imageUrl: finalImageUrls,
      mealType: "data",
      preparingTime: +data.preparingTime.value,
      price: +data.price,
      restaurantId: RestID,
      isCustomMenuItem: data.isCustomMenuItem,
      customMenuItemTypeId: selectedcustomMenuItemTypeId ?? undefined,
      customMenuItemSection: data.customMenuItemSection || "",
      supportsPreOrdering: data.supportsPreOrdering,
      supportPortionSizes: canPortion,
      portions: portions.map((portion) => ({
        displayName: portion.displayName,
        additionalCost: portion.additionalCost,
      })),
      allergenInformation: data?.allergenInformation?.map(
        (item: any) => item.value,
      ),
      foodAttributes: data?.foodAttributes?.map((item: any) => item.value),
      productId: data.productId,
      isCooporateProduct: data.isCooporateProduct,
      organizationIds: selectedOrganizationIds,
      tags: structuredTags,
      dimensions: dimensionSelections,
      tinyId: data.tinyId ? +data.tinyId : 0,
      isSellingProduct: data.isSellingProduct,
      skuId: data.skuId,
    };

    createMenuMutate(object);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCanCustomize(event.target.checked);
    setValue("isCustomMenuItem", event.target.checked);
    if (!event.target.checked) {
      setSelectedOption(null);
      setValue("customMenuItemSection", "");
      clearErrors("customMenuItemSection");
      setSelectedcustomMenuItemTypeId(null);
      setSelectedDimensionValues({});
    }
  };

  const handleCheckboxChangeForPortion = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCanPortion(event.target.checked);
  };

  const handleCorporateSupportChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;
    setisCooporateProduct(isChecked);
    setValue("isCooporateProduct", isChecked);

    if (!isChecked) {
      setValue("organizationIds", []);
      clearErrors("organizationIds");
    } else {
      // Trigger validation when corporate support is enabled
      setTimeout(() => {
        trigger("organizationIds");
      }, 100);
    }
  };

  const handleCanSellChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;
    setIsCanSellProduct(isChecked);
    setValue("isSellingProduct", isChecked);
  };

  const addPortion = () => {
    const portionExists = portions.some(
      (portion) => portion.displayName === portionSize,
    );

    if (portionExists) {
      setPortionErrorMessage("Portion size is already added.");
    } else {
      const portionSizeCost =
        portionSizesData[0].portionSize === portionSize
          ? 0
          : Number(portionPrice);

      setPortions([
        ...portions,
        { displayName: portionSize, additionalCost: portionSizeCost },
      ]);

      setPortionSize("");
      setPortionPrice("");
      setValue("portionSize", "");
      setValue("portionPrice", 0);
      setPortionErrorMessage(null);
    }
  };

  const deletePortion = (index: number) => {
    const updatedPortions = portions.filter((_, i) => i !== index);
    setPortions(updatedPortions);
    setPortionErrorMessage(null);
  };

  const handleSelectChange = (option: any) => {
    setSelectedOption(option);
    setValue("customMenuItemSection", option ? option.value : "");
    clearErrors("customMenuItemSection");

    // Find the selected menu type ID and store it
    if (option) {
      const selectedMenuType = menuTypes.find(
        (type) => type.name === option.value,
      );
      if (selectedMenuType) {
        setSelectedcustomMenuItemTypeId(selectedMenuType.id);
      }
    } else {
      setSelectedcustomMenuItemTypeId(null);
      setSelectedDimensionValues({});
    }
  };

  const handleSelectPortion = (option: any) => {
    setPortionSize(option.value);

    if (option.value === portionSizesData[0].portionSize) {
      setValue("portionPrice", 0);
      setIsPortionPriceDisable(true);
    } else {
      setIsPortionPriceDisable(false);
    }
  };

  const handleOrganizationSearch = (inputValue: string) => {
    setOrganizationSearch(inputValue);
  };

  const handleDimensionValueChange = (
    dimensionId: string,
    selectedValue: any,
  ) => {
    setSelectedDimensionValues((prev) => ({
      ...prev,
      [dimensionId]: selectedValue,
    }));
  };

  const customMenuOptions = menuTypes.map((type) => ({
    label: type.name,
    value: type.name,
  }));

  const isPortionButtonDisabled = !portionSize || !portionPrice;

  return (
    <div>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardHeader style={{ backgroundColor: "#fff" }}>
          <h4>Add Product</h4>
        </CardHeader>
        <CardBody>
          <form
            className="auth-login-form mt-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="mb-3">
              <Col lg={4}>
                <label>Images</label>
              </Col>
              <Col lg={8}>
                <MenuItemImageUpdate
                  exsistImages={[]}
                  uploadImageCallBack={imageUpdateCallbackHandler}
                  onOrderChange={(refs) => setImageOrder(refs)}
                  isDisable={false}
                />
                {errors.imageUrl && (
                  <p className="text-danger">{errors.imageUrl.message}</p>
                )}
              </Col>
            </Row>
            <hr />
            <ControlledRowTextField
              label={"Item Name"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter Item Name"}
              control={control}
              rules={{ required: "Item Name is required" }}
              isRequired={true}
            />
            {errors.displayName && (
              <p className="text-danger">
                {errors.displayName.message as string}
              </p>
            )}
            <hr />
            <ControlledRowTextField
              label={"Abbreviation"}
              inputName={"abbreviation"}
              inputType={"text"}
              placeholder={"Enter Abbreviation"}
              control={control}
            />
            <hr />
            <ControlledRowTextField
              label={"Description"}
              inputName={"description"}
              inputType={"textarea"}
              placeholder={"Enter Description"}
              control={control}
              isRequired={true}
              rules={{ required: "Description is required" }}
            />
            {errors.description && (
              <p className="text-danger">
                {errors.description.message as string}
              </p>
            )}
            <hr />
            <ControlledSelect
              label={"Category"}
              inputName={"category"}
              control={control}
              isMulti={false}
              isRequired={true}
              optionsList={menuCategories}
              rules={{ required: "Category is required" }}
            />
            {errors.category && (
              <p className="text-danger">{errors.category.message as string}</p>
            )}
            <hr />
            {/* <ControlledSelect
              label={"Select Delivery Time"}
              inputName={"preparingTime"}
              control={control}
              isMulti={false}
              optionsList={DELIVERY_TIME}
              isRequired={true}
              rules={{ required: "Delivery Time is required" }}
            />
            {errors.preparingTime && (
              <p className="text-danger">
                {errors.preparingTime.message as string}
              </p>
            )}
            <hr /> */}
            <ControlledRowTextField
              label={"SKU ID"}
              inputName={"skuId"}
              inputType={"text"}
              placeholder={"Enter SKU ID"}
              control={control}
              isRequired={true}
              rules={{ required: "SKU ID is required" }}
            />
            {errors.skuId && (
              <p className="text-danger">
                {errors.skuId.message as string}
              </p>
            )}
            <hr />
            <ControlledRowTextField
              label={"Tiny ID"}
              inputName={"tinyId"}
              inputType={"number"}
              placeholder={"Enter Tiny ID"}
              control={control}

            />
            <hr />

            <ControlledSelect
              label={"Allergic Information"}
              inputName={"allergenInformation"}
              control={control}
              isMulti={true}
              optionsList={allergenOptions}
            />
            <hr />
            <ControlledSelect
              label={"Food Attributes"}
              inputName={"foodAttributes"}
              control={control}
              isMulti={true}
              optionsList={foodAttributesOptions}
            />
            <hr />
            <ControlledSelect
              label={"Filter Tags"}
              inputName={"filterTags"}
              control={control}
              isMulti={true}
              optionsList={filterTagsOptions}
            />

            <hr />

            <Row>
              <Col lg="4">
                <Label htmlFor="canCustomize">
                  Can use for Customize
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="canCustomize"
                  checked={canCustomize}
                  onChange={handleCheckboxChange}
                />
              </Col>
            </Row>

            {canCustomize && (
              <>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label htmlFor="customMenuItemSection">
                      Custom Menu Type
                    </Label>
                  </Col>
                  <Col lg="8">
                    <Select
                      value={selectedOption}
                      onChange={handleSelectChange}
                      options={customMenuOptions}
                      placeholder="Search Product"
                      isSearchable
                      isLoading={isMenuTypesLoading}
                    />
                    {errors.customMenuItemSection && (
                      <p className="text-danger mt-2">
                        {errors.customMenuItemSection.message}
                      </p>
                    )}
                  </Col>
                </Row>

                {/* Dimensions Section */}
                {selectedcustomMenuItemTypeId && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h6 className="mb-3">Select Product Dimensions</h6>
                      </Col>
                    </Row>
                    {isDimensionsLoading ? (
                      // Loading skeleton for dimensions
                      <>
                        {[...Array(2)].map((_, index) => (
                          <Row key={`skeleton-${index}`} className="mb-3">
                            <Col lg="4">
                              <div className="dimension-skeleton-label"></div>
                            </Col>
                            <Col lg="8">
                              <div className="dimension-skeleton-dropdown"></div>
                            </Col>
                          </Row>
                        ))}
                      </>
                    ) : dimensionsData && dimensionsData.length > 0 ? (
                      // Check if there are any dimensions with values
                      (() => {
                        const dimensionsWithValues = dimensionsData.filter(
                          (dimension: any) => {
                            return (
                              dimension.dimensionValue &&
                              dimension.dimensionValue.length > 0
                            );
                          },
                        );

                        if (dimensionsWithValues.length > 0) {
                          // Show actual dimensions
                          return (
                            <>
                              {dimensionsWithValues.map((dimension: any) => {
                                const dimensionValueOptions =
                                  dimension.dimensionValue?.map(
                                    (value: any) => ({
                                      label: value.displayName,
                                      value: value.id,
                                    }),
                                  ) || [];

                                return (
                                  <Row key={dimension.id} className="mb-3">
                                    <Col lg="4">
                                      <Label
                                        htmlFor={`dimension_${dimension.id}`}
                                      >
                                        {dimension.displayName}{" "}
                                        {dimension.isRequired && "*"}
                                      </Label>
                                    </Col>
                                    <Col lg="8">
                                      <Select
                                        id={`dimension_${dimension.id}`}
                                        value={
                                          selectedDimensionValues[
                                          dimension.id
                                          ] || null
                                        }
                                        onChange={(selectedValue) =>
                                          handleDimensionValueChange(
                                            dimension.id,
                                            selectedValue,
                                          )
                                        }
                                        options={dimensionValueOptions}
                                        placeholder={`Select ${dimension.displayName.toLowerCase()}`}
                                        isSearchable
                                        isClearable={!dimension.isRequired}
                                        isLoading={isDimensionsLoading}
                                      />
                                      {dimension.isRequired &&
                                        !selectedDimensionValues[
                                        dimension.id
                                        ] && (
                                          <small className="text-muted mt-1 d-block">
                                            This dimension is required
                                          </small>
                                        )}
                                    </Col>
                                  </Row>
                                );
                              })}
                            </>
                          );
                        } else {
                          // Show no dimensions message when dimensions exist but have no values
                          return (
                            <Row className="mb-3">
                              <Col lg="12">
                                <div className="no-dimensions-message">
                                  <i className="fas fa-info-circle no-dimensions-icon"></i>
                                  <p className="no-dimensions-title">
                                    No dimensions configured
                                  </p>
                                  <small className="no-dimensions-description">
                                    This custom menu type doesn't have any
                                    dimensions set up yet.
                                    <br />
                                    You can proceed without selecting
                                    dimensions.
                                  </small>
                                </div>
                              </Col>
                            </Row>
                          );
                        }
                      })()
                    ) : (
                      // Fallback when no dimensions data
                      <Row className="mb-3">
                        <Col lg="12">
                          <div className="no-dimensions-message">
                            <i className="fas fa-info-circle no-dimensions-icon"></i>
                            <p className="no-dimensions-title">
                              No dimensions configured
                            </p>
                            <small className="no-dimensions-description">
                              This custom menu type doesn't have any dimensions
                              set up yet.
                              <br />
                              You can proceed without selecting dimensions.
                            </small>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
                <br />
              </>
            )}

            

            {/* Can Sell Section */}
            <hr />
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="isCanSellProduct"
                >
                  Can Sell
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isCanSellProduct"
                  checked={isCanSellProduct}
                  onChange={handleCanSellChange}
                />
              </Col>
            </Row>

            {isCanSellProduct && (
              <>
              <hr />
            <ControlledRowTextField
              label={"Product ID"}
              inputName={"productId"}
              inputType={"text"}
              placeholder={"Enter Product ID"}
              control={control}
              isRequired={true}
              rules={{ required: "Product ID is required" }}
            />
            {errors.productId && (
              <p className="text-danger">
                {errors.productId.message as string}
              </p>
            )}
            <hr />

            <ControlledRowTextField
              label={"Product Price (Rs.)"}
              inputName={"price"}
              inputType={"number"}
              placeholder={"Enter Product Price"}
              isRequired={true}
              control={control}
              rules={{
                required: "Product Price is required",
                // min: {
                //   value: 0.01,
                //   message: "Product Price must be greater than 0",
                // },
              }}
            />
            {errors.price && (
              <p className="text-danger">{errors.price.message as string}</p>
            )}
            <hr />
                
                {/* Corporate Support Section */}
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="isCooporateProduct"
                    >
                      Corporate Product
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isCooporateProduct"
                      checked={isCooporateProduct}
                      onChange={handleCorporateSupportChange}
                    />
                  </Col>
                </Row>

                {isCooporateProduct && (
                  <>
                    <hr />
                    <Row>
                      <Col lg="4">
                        <Label htmlFor="organizations">Organizations *</Label>
                      </Col>
                      <Col lg="8">
                        <ControlledSelect
                          label={""}
                          inputName={"organizationIds"}
                          control={control}
                          isMulti={true}
                          optionsList={organizationOptions}
                          placeholder="Search organizations..."
                          onInputChange={handleOrganizationSearch}
                          isLoading={isOrganizationsLoading}
                          rules={{
                            validate: (value: any) =>
                              validateOrganizations(value, isCooporateProduct),
                          }}
                        />
                        {errors.organizationIds && (
                          <p className="text-danger mt-2">
                            {errors.organizationIds.message}
                          </p>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                <hr />

                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="supportsPreOrdering"
                    >
                      Supports Pre-Ordering
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="supportsPreOrdering"
                      checked={isPreOrder}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setIsPreOrder(event.target.checked);
                        setValue("supportsPreOrdering", event.target.checked);
                      }}
                    />
                  </Col>
                </Row>

                {/* <hr /> */}

                {/* <hr />
            <Row className="mb-3">
              <Col lg={4}>
                <Label>Portion Available</Label>
              </Col>
              <Col lg={8}>
                <input
                  type="checkbox"
                  checked={canPortion}
                  className="form-check-input"
                  onChange={handleCheckboxChangeForPortion}
                  value={portionSize}
                />

                {canPortion && (
                  <>
                    <hr />
                    <div className="portion-section">
                      <div className="portion-inputs">
                        <Row>
                          <Col md={5} className="mt-1">
                            <ControlledRowSelectPortion
                              inputName="portionSize"
                              control={control}
                              optionsList={portionSizesOptions}
                              placeholder="Select portion size"
                              onChange={(option: any) =>
                                handleSelectPortion(option)
                              }
                            />
                            <br />
                          </Col>
                          <Col md={5}>
                            <ControlledRowTextFieldForPortion
                              inputName={"portionPrice"}
                              inputType={"number"}
                              placeholder={"Enter portion price"}
                              control={control}
                              isDisabled={isPortionPriceDisable}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value >= 0) {
                                  setPortionPrice(e.target.value);
                                } else {
                                  setPortionPrice("");
                                  setPortionErrorMessage(
                                    "Portion price cannot be negative.",
                                  );
                                }
                              }}
                            />
                          </Col>

                          <Col md={2} className="mt-3">
                            <ButtonComponent
                              type="button"
                              titel="+Add"
                              isDisabled={
                                portionSizesData?.[0]?.portionSize ===
                                  portionSize
                                  ? false
                                  : isPortionButtonDisabled
                              }
                              onClick={addPortion}
                            />
                          </Col>
                        </Row>
                      </div>
                      {portionErrorMessage && (
                        <div className="text-danger mt-2">
                          {portionErrorMessage}
                        </div>
                      )}
                      <Table>
                        <thead>
                          <tr>
                            <th>Size</th>
                            <th>Price</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {portions.map((portion, index) => (
                            <tr key={index}>
                              <td>{portion.displayName}</td>
                              <td>{portion.additionalCost}</td>
                              <td>
                                <Button
                                  variant="light"
                                  onClick={() => deletePortion(index)}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    title="Delete"
                                    color="#F24E1E"
                                  />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </>
                )}
              </Col>
            </Row> */}
              </>
            )}
            <hr />

            {/* Corporate Support Section */}
            {/* <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="isCooporateProduct"
                >
                  Corporate Product
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isCooporateProduct"
                  checked={isCooporateProduct}
                  onChange={handleCorporateSupportChange}
                />
              </Col>
            </Row>

            {isCooporateProduct && (
              <>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label htmlFor="organizations">Organizations *</Label>
                  </Col>
                  <Col lg="8">
                    <ControlledSelect
                      label={""}
                      inputName={"organizationIds"}
                      control={control}
                      isMulti={true}
                      optionsList={organizationOptions}
                      placeholder="Search organizations..."
                      onInputChange={handleOrganizationSearch}
                      isLoading={isOrganizationsLoading}
                      rules={{
                        validate: (value: any) =>
                          validateOrganizations(value, isCooporateProduct),
                      }}
                    />
                    {errors.organizationIds && (
                      <p className="text-danger mt-2">
                        {errors.organizationIds.message}
                      </p>
                    )}
                  </Col>
                </Row>
              </>
            )}

            <hr />

            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="supportsPreOrdering"
                >
                  Supports Pre-Ordering
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="supportsPreOrdering"
                  checked={isPreOrder}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setIsPreOrder(event.target.checked);
                    setValue("supportsPreOrdering", event.target.checked);
                  }}
                />
              </Col>
            </Row>

            <hr /> */}

            {/* <hr />
            <Row className="mb-3">
              <Col lg={4}>
                <Label>Portion Available</Label>
              </Col>
              <Col lg={8}>
                <input
                  type="checkbox"
                  checked={canPortion}
                  className="form-check-input"
                  onChange={handleCheckboxChangeForPortion}
                  value={portionSize}
                />

                {canPortion && (
                  <>
                    <hr />
                    <div className="portion-section">
                      <div className="portion-inputs">
                        <Row>
                          <Col md={5} className="mt-1">
                            <ControlledRowSelectPortion
                              inputName="portionSize"
                              control={control}
                              optionsList={portionSizesOptions}
                              placeholder="Select portion size"
                              onChange={(option: any) =>
                                handleSelectPortion(option)
                              }
                            />
                            <br />
                          </Col>
                          <Col md={5}>
                            <ControlledRowTextFieldForPortion
                              inputName={"portionPrice"}
                              inputType={"number"}
                              placeholder={"Enter portion price"}
                              control={control}
                              isDisabled={isPortionPriceDisable}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value >= 0) {
                                  setPortionPrice(e.target.value);
                                } else {
                                  setPortionPrice("");
                                  setPortionErrorMessage(
                                    "Portion price cannot be negative.",
                                  );
                                }
                              }}
                            />
                          </Col>

                          <Col md={2} className="mt-3">
                            <ButtonComponent
                              type="button"
                              titel="+Add"
                              isDisabled={
                                portionSizesData?.[0]?.portionSize ===
                                  portionSize
                                  ? false
                                  : isPortionButtonDisabled
                              }
                              onClick={addPortion}
                            />
                          </Col>
                        </Row>
                      </div>
                      {portionErrorMessage && (
                        <div className="text-danger mt-2">
                          {portionErrorMessage}
                        </div>
                      )}
                      <Table>
                        <thead>
                          <tr>
                            <th>Size</th>
                            <th>Price</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {portions.map((portion, index) => (
                            <tr key={index}>
                              <td>{portion.displayName}</td>
                              <td>{portion.additionalCost}</td>
                              <td>
                                <Button
                                  variant="light"
                                  onClick={() => deletePortion(index)}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    title="Delete"
                                    color="#F24E1E"
                                  />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </>
                )}
              </Col>
            </Row> */}
            <div style={{ textAlign: "end" }} className="mb-3">
              {isLoading ? (
                <ButtonComponent
                  type={"submit"}
                  icon={<FontAwesomeIcon icon={faSpinner} spin />}
                  titel="Saving..."
                  isDisabled={true}
                ></ButtonComponent>
              ) : (
                <ButtonComponent
                  type="submit"
                  icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                  titel="Save"
                  isDisabled={isLoading}
                />
              )}
            </div>
          </form>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddItemForm;
